namespace RioERP.Users {
    export interface CustomersExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class CustomersExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.CustomersExcelImportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomersExcelImportForm.init)  {
                CustomersExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(CustomersExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
